<template>
  <b-container tag="article" data-aos="fade-up">
    <b-img-lazy
      class="w-100"
      alt="Picture of a bunch of flowers"
      src="../../../assets/news/flowers.jpg"
    />
    <h1 class="mt-5 mb-2 text-primary">Winner of the 100th Trip!</h1>
    <h2 class="mb-2 text-info">Feb 12, 2018</h2>
    <p>
      Congratulations to Doreen and George from Thorney who were the lucky
      winners of the 100th Trip completed by the Car Scheme since our launch in
      April 2017. They were surprised and pleased to receive a free trip to and
      from Lincoln courtesy of our driver Rob, also from Thorney. Scheme
      Co-ordinator Clare delivered this lovely floral arrangement to their home
      a couple of days later to mark the occasion. It is great to see the car
      scheme being so well used by residents from our local villages so a big
      thank you to you all for your support.
    </p>
  </b-container>
</template>

<script>
export default {
  name: "WinnerOf100Trip",
};
</script>